import React from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { LeadSection } from './components/LeadSection';
import { AgitationSection } from './components/AgitationSection';
import { SolutionsFailSection } from './components/SolutionsFailSection';
import { MechanismSection } from './components/MechanismSection';
import { ProductIntro } from './components/ProductIntro';
import { IncludesSection } from './components/IncludesSection';
import { OriginStory } from './components/OriginStory';
import { TestimonialsSection } from './components/TestimonialsSection';
import { ForWhomSection } from './components/ForWhomSection';
import { InvestmentSection } from './components/InvestmentSection';
import { RiskReversal } from './components/RiskReversal';
import { UrgencySection } from './components/UrgencySection';
import { FaqSection } from './components/FaqSection';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="min-h-screen bg-charcoal text-offwhite font-sans selection:bg-sand/30 selection:text-sand" data-id="element-0" data-mp="3ijfw82xf22g7">
      <Header data-id="element-1" data-mp="3mjq45l4rr2xp" />

      <main data-id="element-2" data-mp="3mj6k9yvk64h1">
        <HeroSection data-id="element-3" data-mp="3rcj6618urx63" />
        <LeadSection data-id="element-4" data-mp="3rbzomln47asl" />
        <AgitationSection data-id="element-5" data-mp="3rdkl4gszp3t3" />
        <SolutionsFailSection data-id="element-6" data-mp="3recctgjguhe3" />
        <MechanismSection data-id="element-7" data-mp="6hqtghuuhen" />
        <ProductIntro data-id="element-8" data-mp="4wylxj0jajy" />
        <IncludesSection data-id="element-9" data-mp="56lvdcob3ly" />
        <OriginStory data-id="element-10" data-mp="2zl3alhpbj03q" />
        <TestimonialsSection data-id="element-11" data-mp="2zllcouynw8jk" />
        <ForWhomSection data-id="element-12" data-mp="2zmemk4sx3e5x" />
        <InvestmentSection data-id="element-13" data-mp="2zn6bwxvx8fnr" />
        <RiskReversal data-id="element-14" data-mp="33mf1rrnubte1" />
        <UrgencySection data-id="element-15" data-mp="33nq6btp41567" />
        <FaqSection data-id="element-16" data-mp="33n6wz1dizp3s" />
        <FinalCTA data-id="element-17" data-mp="33oi337ug18y2" />
      </main>

      <Footer data-id="element-18" data-mp="38l8gfnev5qfs" />
    </div>;
}